import { PortableTextTypeComponentProps } from "@portabletext/react";
import CallToAction, { CallToActionProps } from "@/components/CallToAction";
import SVGAddress from "@/lib/svg/SVGAddress";
import SVGDate from "@/lib/svg/SVGDate";
import SVGWeb from "@/lib/svg/SVGWeb";
import {
  CardInfo,
  Label,
  Link,
  IconWrapper,
  Title,
  LabelText,
} from "./styles";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";

export type ArticleEventProps = PortableTextTypeComponentProps<{
  address: string | null;
  date: string | null;
  link: {
    title: any;
    url: string | null;
    blank: boolean;
  } | null;
}>;

const ArticleEvent: React.FC<ArticleEventProps> = (props) => {
  const { address, date, link } = props.value;
  const defaultLocale = "it";

  const { locale = defaultLocale } = useRouter();
  const t = {
    addressLabel: useTranslation("marketingPage.location.address", locale),
    dateLabel: useTranslation("articlePage.date", locale),
    linkLabel: useTranslation("articlePage.website", locale),
  };

  return (
    <CardInfo>
      {t.addressLabel && address && (
        <Label>
          <IconWrapper>
            <SVGAddress />
          </IconWrapper>
          <LabelText>{t.addressLabel}:</LabelText>
          <Title>{address}</Title>
        </Label>
      )}
      {t.dateLabel && date && (
        <Label>
          <IconWrapper>
            <SVGDate />
          </IconWrapper>
          <LabelText>{t.dateLabel}:</LabelText>
          <Title>{date}</Title>
        </Label>
      )}
      {t.linkLabel && link && link.title && (
        <Label>
          <IconWrapper>
            <SVGWeb />
          </IconWrapper>
          <LabelText>{t.linkLabel}:</LabelText>
          <Link href={link.url || "/"} target={`${link?.blank ? "_blank" : ""}`}>
            <Title>{link.title[locale] || link.title[defaultLocale]}</Title>
          </Link>
        </Label>
      )}
    </CardInfo>
  );
};

export default ArticleEvent;
